var React = require('react');

function Graph232px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 22H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v19h29a1 1 0 1 1 0 2zM26 7c-.224 0-.436-.045-.637-.114l-5.402 4.727A2.003 2.003 0 0 1 18 14c-1.103 0-2-.897-2-2 0-.178.031-.347.074-.511l-2.127-2.127-4.984 4.272c.022.119.037.241.037.366 0 1.103-.898 2-2 2-1.103 0-2-.897-2-2s.897-2 2-2c.231 0 .45.047.657.12l5.692-4.879c.042-.036.092-.049.137-.077.059-.036.114-.076.178-.099.059-.021.118-.025.179-.035.066-.01.13-.025.197-.022.062.002.12.021.181.035.064.015.127.024.187.051.061.027.111.071.166.111.044.031.094.049.133.088l2.781 2.782c.165-.044.334-.075.512-.075.224 0 .436.045.637.114l5.402-4.727A2.002 2.002 0 0 1 26 3c1.102 0 2 .897 2 2s-.898 2-2 2z","key":1})]);
}

Graph232px.displayName = "Graph232px";

Graph232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};

module.exports = Graph232px;

Graph232px.default = Graph232px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/graph-2-32px.svg
// module id = 1099
// module chunks = 0